import { render, staticRenderFns } from "./tab-event.vue?vue&type=template&id=0934a2ff&scoped=true"
import script from "./tab-event.vue?vue&type=script&lang=js"
export * from "./tab-event.vue?vue&type=script&lang=js"
import style0 from "./tab-event.vue?vue&type=style&index=0&id=0934a2ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934a2ff",
  null
  
)

export default component.exports